import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout } from "antd";

import appActions from "../../redux/app/actions";
import TopbarUser from "./topbarUser";
import TopbarWrapper from "./topbar.style";
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";

import "./customTopbar.css";

const { Header } = Layout;
const { toggleCollapsed, changeAccentColor } = appActions;
const customizedTheme = themes[themeConfig.theme];

const ACCENT_COLORS = [
  { label: "IHCL Blue (Default)", value: "#002a49" },
  { label: "Navy",    value: "#1a3a5c" },
  { label: "Indigo",  value: "#3949ab" },
  { label: "Blue",    value: "#1e88e5" },
  { label: "Teal",    value: "#00897b" },
  { label: "Green",   value: "#43a047" },
  { label: "Amber",   value: "#ffb300" },
  { label: "Orange",  value: "#f57c00" },
  { label: "Red",     value: "#e53935" },
  { label: "Purple",  value: "#8e24aa" },
];

class ThemePicker extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.wrapperRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  }

  render() {
    const { accentColor, onColorChange } = this.props;
    const { open } = this.state;

    return (
      <div ref={this.wrapperRef} style={{ position: "relative" }}>
        {/* Trigger button */}
        <button
          title="Change theme color"
          onClick={() => this.setState({ open: !open })}
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            border: "2px solid #e8e8e8",
            background: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
            outline: "none",
          }}
        >
          {/* Paint palette icon */}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#555" strokeWidth="1.5" fill="none"/>
            <circle cx="8"  cy="10" r="1.5" fill={accentColor} />
            <circle cx="12" cy="8"  r="1.5" fill="#43a047" />
            <circle cx="16" cy="10" r="1.5" fill="#1e88e5" />
            <circle cx="15" cy="15" r="1.5" fill="#f57c00" />
            <circle cx="9"  cy="15" r="1.5" fill="#8e24aa" />
          </svg>
        </button>

        {/* Color swatch popover */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: 40,
              right: 0,
              background: "#fff",
              borderRadius: 10,
              boxShadow: "0 8px 24px rgba(0,0,0,0.14)",
              padding: "12px 14px",
              zIndex: 9999,
              minWidth: 190,
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 600, color: "#888", marginBottom: 10, letterSpacing: "0.05em", textTransform: "uppercase" }}>
              Theme Color
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8 }}>
              {ACCENT_COLORS.map((c) => (
                <button
                  key={c.value}
                  title={c.label}
                  onClick={() => {
                    onColorChange(c.value);
                    this.setState({ open: false });
                  }}
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: c.value,
                    border: accentColor === c.value ? "3px solid #333" : "2px solid transparent",
                    cursor: "pointer",
                    outline: "none",
                    boxShadow: accentColor === c.value ? "0 0 0 2px #fff inset" : "none",
                    transition: "transform 0.1s",
                  }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

class Topbar extends Component {
  render() {
    const { toggleCollapsed, changeAccentColor, accentColor } = this.props;
    const collapsed = this.props.collapsed && !this.props.openDrawer;
    const isNarrow =
      this.props.App.view !== "DesktopView" ||
      (typeof window !== "undefined" && window.innerWidth <= 991);

    const styling = {
      background: "#ffffff",
      position: "relative",
      width: "100%",
      height: 60,
      flexShrink: 0,
      zIndex: 100,
      borderBottom: "1px solid #e8e8e8",
      padding: isNarrow ? "0 12px" : "0 24px",
      lineHeight: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: isNarrow ? "space-between" : "flex-end",
    };

    return (
      <TopbarWrapper>
        <Header
          style={styling}
          className={
            collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
          }
        >
          {isNarrow && (
            <div className="isoLeft">
              <button
                type="button"
                aria-label={collapsed ? "Open menu" : "Close menu"}
                className={
                  collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
                }
                style={{ color: customizedTheme.textColor }}
                onClick={toggleCollapsed}
              >
                {collapsed ? (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="3" y1="6" x2="21" y2="6" />
                    <line x1="3" y1="12" x2="21" y2="12" />
                    <line x1="3" y1="18" x2="21" y2="18" />
                  </svg>
                ) : (
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="6" y1="6" x2="18" y2="18" />
                    <line x1="6" y1="18" x2="18" y2="6" />
                  </svg>
                )}
              </button>
            </div>
          )}

          <ul className="isoRight">
            <li style={{ display: "flex", alignItems: "center" }}>
              <ThemePicker
                accentColor={accentColor}
                onColorChange={changeAccentColor}
              />
            </li>
            <li
              onClick={() => this.setState({ selectedItem: "user" })}
              className="isoUser"
            >
              <TopbarUser />
            </li>
          </ul>
        </Header>
      </TopbarWrapper>
    );
  }
}

export default connect(
  (state) => ({
    ...state.App,
    dashboardView: state.Auth,
    App: state.App,
    accentColor: state.App.accentColor,
  }),
  { toggleCollapsed, changeAccentColor }
)(Topbar);
